export default __webpack_public_path__ + "static/media/deliland-gseed-icon.5bb8f287.png";